import React from 'react';

export default function Intro({ onNext }) {
  return (
    <div className="max-w-3xl mx-auto" data-testid="bta-intro">
      <div className="bg-white rounded-lg border border-slate-200 shadow-sm p-10">
        <div className="text-xs uppercase tracking-wider text-[#2FA163] font-semibold mb-2">
          Free tool · I Need Numbers
        </div>
        <h1 className="text-3xl font-bold text-[#092825] mb-4">
          Broker &amp; Team Analyzer
        </h1>
        <p className="text-lg text-slate-700 mb-6 leading-relaxed">
          Thinking about moving brokerages or joining a team? This tool shows you
          exactly what you&rsquo;d actually take home at each option, side by side —
          so you can make the decision on numbers instead of a pitch.
        </p>

        <div className="bg-slate-50 border border-slate-200 rounded p-6 mb-6">
          <h3 className="font-semibold text-[#092825] mb-4">How it works</h3>
          <ol className="space-y-3 text-slate-700">
            <li className="flex gap-3">
              <span className="shrink-0 w-7 h-7 rounded-full bg-[#2FA163] text-white font-bold text-sm flex items-center justify-center">1</span>
              <div>
                <strong>Your current brokerage.</strong> Tell us where you are
                today — your split, your cap, the fees you pay. We pre-fill
                typical values for the big cap-model brokerages so you can start
                fast and edit what&rsquo;s different.
              </div>
            </li>
            <li className="flex gap-3">
              <span className="shrink-0 w-7 h-7 rounded-full bg-[#2FA163] text-white font-bold text-sm flex items-center justify-center">2</span>
              <div>
                <strong>Add up to 4 options to compare.</strong> Each one can be
                a different brokerage, a brokerage + team, or the same
                brokerage you&rsquo;re at now under different team terms. You
                name each column so you can keep them straight.
              </div>
            </li>
            <li className="flex gap-3">
              <span className="shrink-0 w-7 h-7 rounded-full bg-[#2FA163] text-white font-bold text-sm flex items-center justify-center">3</span>
              <div>
                <strong>Edit the deal pipeline.</strong> We start you with a
                sample year of deals. Edit sale prices, commission rates,
                close months — or wipe it and add your own actual pipeline.
                The tool does the math on every deal at every brokerage.
              </div>
            </li>
            <li className="flex gap-3">
              <span className="shrink-0 w-7 h-7 rounded-full bg-[#2FA163] text-white font-bold text-sm flex items-center justify-center">4</span>
              <div>
                <strong>See the results.</strong> Annual take-home at each
                option. Effective split percentage. Which month you&rsquo;d hit
                cap. Dollar and percent difference vs. where you are today. And
                the net on every single deal at every brokerage, so nothing&rsquo;s
                hiding in an average.
              </div>
            </li>
          </ol>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-6 text-sm">
          <div className="border border-slate-200 rounded p-3 bg-white">
            <div className="font-semibold text-[#092825] mb-1">Takes about 5 minutes</div>
            <div className="text-slate-600">Defaults are pre-filled so you only edit what&rsquo;s different from typical.</div>
          </div>
          <div className="border border-slate-200 rounded p-3 bg-white">
            <div className="font-semibold text-[#092825] mb-1">Nothing saved</div>
            <div className="text-slate-600">No login, no email. Your numbers stay in your browser and disappear when you close it.</div>
          </div>
          <div className="border border-slate-200 rounded p-3 bg-white">
            <div className="font-semibold text-[#092825] mb-1">Built for desktop</div>
            <div className="text-slate-600">Four columns of comparison really do want a wide screen.</div>
          </div>
        </div>

        <div className="flex items-center justify-between">
          <div className="text-xs text-slate-500 italic">
            Estimates only. Confirm every number with the brokerage before you make a move.
          </div>
          <button
            type="button"
            onClick={onNext}
            data-testid="bta-intro-start-btn"
            className="bg-gradient-to-br from-[#2FA163] to-[#286C4E] hover:opacity-90 text-white font-semibold px-6 py-2.5 rounded shadow transition-opacity whitespace-nowrap"
          >
            Let&rsquo;s get started →
          </button>
        </div>
      </div>
    </div>
  );
}
